import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();
export async function getAllSalesAgents(callback) {
	console.log('running getallsalesagents');

	await firebaseRef
		.ref('kavtek_sales_agents/' + PROJECT_CODE.projectCode)
		.on('value', (snapshot) => {
			var salesAgentArr = [];
			var salesAgentsParentObj = snapshot.val();

			console.log('salesAgentsPsrentObj', salesAgentsParentObj);

			var salesAgentsKeys = Object.keys(salesAgentsParentObj);

			console.log('salesagentskeys', salesAgentsKeys);

			//now we are gonna iterate through the sales agents keys
			salesAgentsKeys.forEach((key) => {
				var salesAgentId = salesAgentsParentObj[key]['createrID'];
				var salesAgentName = salesAgentsParentObj[key]['name'];
				var salesAgentEmail = salesAgentsParentObj[key]['email'];

				var salesAgentDetailsObj = {
					salesAgentId: salesAgentId,
					salesAgentName: salesAgentName,
					salesAgentEmail: salesAgentEmail,
				};

				salesAgentArr.push(salesAgentDetailsObj);
			});

			console.log(
				'this is the sales agent from the get all salesagent api:',
				salesAgentArr
			);

			callback(salesAgentArr);
		});
}
